import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { ContractProvider } from '../providers/contract.provider';
import { IdInterface, OrderClientInterface } from '../data';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface GetContractSignatoriesUseCaseParams {
    clientCode?: IdInterface;
}

@Injectable()
export class GetContractSignatoriesUseCase
    implements UseCaseWithParam<GetContractSignatoriesUseCaseParams, Observable<Transaction<OrderClientInterface[]>>>
{
    constructor(private contractProvider: ContractProvider) {}

    bind(params: GetContractSignatoriesUseCaseParams): Observable<Transaction<OrderClientInterface[]>> {
        return this.contractProvider.current().pipe(
            switchMap((transaction) =>
                transaction.map(
                    (contract) => this.contractProvider.signatories(contract.encryptedCode, params.clientCode),
                    (throwable) => of(Transaction.error(throwable.message))
                )
            )
        );
    }
}
